'use strict';
import angular from 'angular';
import tritonTeamsHtmlUrl from './views/tritonTeamsList.html';
var app = angular.module('app.tritonTeams.component', []);
app.component('tritonAdsTeams', {
    bindings: {
        showActions: '<',
        selectedTritonTeam: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId: '='
    },
    templateUrl: tritonTeamsHtmlUrl,
    controller: function (ProductService) {
        var self = this;
        self.selectedTeam = '';
        self.tritonTeamsList = [];
        self.toggleTeamsList = function () {
            self.showActions = !self.showActions;
        };
        self.selectTeam = function (team) {
            self.selectedTeam = team.name;
            self.showActions = false;
            self.selectedTritonTeam= self.tritonTeamsList.filter(function (item) {
                return item.name === self.selectedTeam;
            });

        };

        self.getTritonTeam = function () {
            var selectedTritonTeam = self.selectedTeam;
            ProductService.getTritonTeamContents({
                clientId: self.clientId,
                clusterId: self.clusterId
            }).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        var teams = {
                            id: content.id,
                            name: content.name
                        };
                        self.tritonTeamsList.push(teams);
                    });
                    _.each(self.selectedTritonTeam, function (item) {
                        item.tritonTeamsList = angular.copy(self.tritonTeamsList);
                    })
                }
            }, function (error) {
            });
        }
        self.initComponent = function () {
            if (self.selectedTritonTeam && !_.isEmpty(self.selectedTritonTeam)) {
                self.selectedTritonTeam = JSON.parse(self.selectedTritonTeam);
                self.showActions = self.isFormEdit;
                self.editMode = true;
                self.enableViewMode = false;
                self.getTritonTeam();
            } else {
                self.selectedTritonTeam = '';
                self.showActions = false;
                self.enableViewMode = false;
                self.getTritonTeam();
            }
            if ( self.selectedTritonTeam != '') {
                self.selectedTeam = self.selectedTritonTeam[0].name;
            }
        };
        self.initComponent();
    }
});